import {
  FlexColumn,
} from '@equifinance/shared';
import styled from 'styled-components';
import { ChecklistSection } from '../../../../ChecklistPage';
import { GenericSection } from '../../../GenericSection';
import AvmResult from './AvmResult';
import { useChecklistContext } from '../../../../../../contexts/checklist';

const AvmResultsWrapper = styled(FlexColumn)`${({ theme }) => `
  padding: ${theme.padding[1]} ${theme.padding[9]};
  gap: ${theme.padding[5]};
`}`;

const P = styled.p`${({ theme }) => `
  font-size: ${theme.fontSize[2]};
  color: ${theme.colours.neutral[2]};
`}`;

export default function AvmResultsSection() {
  const { checklist } = useChecklistContext();
  const { valuation } = checklist ?? {};
  const { avmResult } = valuation ?? {};
  const noSearchesRun = !avmResult?.length;

  return (
    <GenericSection
      subSection={ChecklistSection.VALUATION_AVM_RESULTS}
      level={1}
    >
      <AvmResultsWrapper>
        {avmResult?.map((result) => (<AvmResult key={result.id} avmResult={result} />))}
        {noSearchesRun && <P>No searches run</P>}
      </AvmResultsWrapper>
    </GenericSection>
  );
}
